import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _18mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"18mp"} ref={ref}/>
});

_18mpIcon.displayName = "_18mpIcon";
